import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../../data/volumes';
export function Volumes() {
  return <section className="w-full bg-bone px-4 py-14 sm:px-6 sm:py-20" data-id="element-248" data-mp="2x19uoe6joaa1">
      <div className="mx-auto w-full max-w-3xl" data-id="element-249" data-mp="2wzgpl3bkxy45">
        <SectionHeading eyebrow="📘 The Clinical Library" title="6 Specialized Volumes, One Diagnostic Logic" data-id="element-250" data-mp="2t07x01sa06a6" />

        <ol className="mt-10 space-y-4" data-id="element-251" data-mp="2o1wk1i6opfnq">
          {volumes.map(volume => <li key={volume.label} className="rounded-3xl border border-slate-200 bg-white p-5 shadow-card sm:p-7" data-id="element-252" data-mp="2j93g2wj1ibcp">
              <span className="inline-flex rounded-full bg-navy-950 px-3 py-1 text-[10px] font-extrabold tracking-[0.16em] text-gold-400" data-id="element-253" data-mp="29bz2hl39fo7i">
                {volume.label}
              </span>
              <h3 className="mt-3.5 font-display text-xl font-bold leading-snug text-navy-950 sm:text-2xl" data-id="element-254" data-mp="20b0w4w5cn4lr">
                {volume.title}
              </h3>
              <div className="mt-3 space-y-2.5" data-id="element-255" data-mp="3342ylkhkcaku">
                {volume.paragraphs.map(p => <p key={p} className="text-[14px] leading-relaxed text-slate-600" data-id="element-256" data-mp="37xxesdxym7f6">
                    {p}
                  </p>)}
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-8 max-w-xl text-center font-display text-lg italic text-navy-900" data-id="element-257" data-mp="2y6t0zhk0sslx">
          Because the right treatment decision starts with the right diagnosis.
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-258" data-mp="3quovqgq14ag2">
          <CTAButton label="I want all 6 volumes" subline="Instant download after payment" data-id="element-259" data-mp="3cvpevv8rczug" />
        </div>
      </div>
    </section>;
}